
import React from "react";
import ReactApexChart from "react-apexcharts";

const LineCharts = ({ dqScoreTrendGraph }) => {
  if (!dqScoreTrendGraph?.data?.length) {
    return <p>No trend data available</p>;
  }

  

  const trace = dqScoreTrendGraph.data[0];
  const categories = trace.x || [];
  const values = trace.y || [];

  const series = [
    {
      name: trace.name || "DQ Score",
      data: values,
    },
  ];

  const options = {
    chart: {
      height: 600,
      type: "area",
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    colors: ["#80C68D"],
    dataLabels: { enabled: false },
    stroke: {
      curve: "smooth",
      width: 3, 
    },
    fill: {
      type: "solid", 
      opacity: 0.1,
      colors: ["#d9f5ebff"], 
    },
    title: {
      text: dqScoreTrendGraph.layout?.title || "DQ Score Trend",
      align: "left",
      style: {
        fontSize: "15px",
        fontWeight: 600,
 fontFamily: "Poppins, sans-serif",      },
    },
    grid: {
      row: { colors: ["#f3f3f3",], opacity: 0.5 },
    },
  xaxis: {
  categories: categories,
  title: {
    text: dqScoreTrendGraph.layout?.xaxis?.title || "Month",
    style: {
      fontSize: "15px",
      fontWeight: 600,
      fontFamily: "Poppins, sans-serif",
    },
  },
},
   yaxis: {
  min: dqScoreTrendGraph.layout?.yaxis?.range?.[0] ?? 0,
  max: dqScoreTrendGraph.layout?.yaxis?.range?.[1] ?? 100,
  title: {
    text: dqScoreTrendGraph.layout?.yaxis?.title || "Score",
    style: {
      fontSize: "15px",
      fontWeight: 600,
      fontFamily: "Poppins, sans-serif",
    },
  },
},

  };

  return (
    <div id="chart" className="flex-1 w-full h-full poppins-regular mt-2">
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height="100%"
      />
    </div>
  );
};

export default LineCharts;
